import styled from "styled-components";

export const CaseGrid = styled.div`
margin: auto;
display: flex;
flex-wrap: wrap;
column-gap: 25px;
row-gap: 25px;
justify-content: center;
`
export const CaseElement = styled.a`
text-decoration: none;
display: flex;
flex-direction: column;
width: 300px;
height: 300px;
border-radius: 20px;
transition: all 300ms ease-out;
& img {
    object-fit: cover;
    height: 200px;
}
& h1 {
    text-align: center;
    color: black;
    transition: all 300ms ease-out;
}
&:hover {
    cursor: pointer;
    box-shadow: 0 10px 30px rgb(0 0 0 / 25%);
    & h1 {
        color: ${({ theme }) => theme.mainColors.darkblu};
    }
}
`